import { Navigate } from "react-router-dom";
import { useAuth } from "../lib/auth";

export default function AdminRoute({ children }) {
  const { user } = useAuth();

  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="font-mono-fig text-sm text-muted-foreground">Loading…</div>
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  if (user.role !== "admin") return <Navigate to="/dashboard" replace />;
  return children;
}
